import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=debcf3bc&scoped=true"
import script from "./EditGroup.vue?vue&type=script&lang=ts"
export * from "./EditGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debcf3bc",
  null
  
)

export default component.exports